<template>
    <div>
        <el-dialog :modal-append-to-body="false" :close-on-click-modal="false" custom-class="delCarMusic" title="授权书"
            :visible.sync="payDialogVisible" width="690px" :before-close="handlePayClose">
            <el-divider></el-divider>
            <div class="pay">
                <div class="info">
                    <div class="info_box">
                        <div class="info_item">
                            <div class="flex">
                                <div class="info_item_name">
                                    <p>歌曲用途</p>
                                </div>
                                <el-input :readonly="purposeFlag" v-model="purpose" placeholder="请输入歌曲用途">
                                </el-input>
                            </div>
                        </div>
                        <uploadVue v-if="(!applyInfo.deposit_info && !applyInfo.qualificat && applyInfo.type == 2)"
                            @taxpayer="taxpayer" @deposit="deposit"></uploadVue>
                        <div class="info_item" v-for="i in personList" :key="i.name">
                            <div class="flex">
                                <div class="info_item_name">
                                    <p>{{ i.name }}</p>
                                </div>
                                <el-input :readonly="i.purposeFlag" v-model="i.msg" :placeholder="i.placeholder">
                                </el-input>
                            </div>
                            <p v-if="i.tips" class="tips">{{ i.tips }}</p>
                        </div>
                    </div>
                </div>
                <p class="tips">注意：以上内容作为授权书的关键信息，一旦提交不支持修改，请务必填写准确。</p>
            </div>
            <p slot="footer" class="dialog-footer payFooter">
                <el-button plain @click="handClick">预览授权书</el-button>
                <el-button type="primary" @click="putIn">申请授权</el-button>
            </p>
        </el-dialog>
        <div class="wordPreview">
            <!-- 预览证书 -->
            <el-dialog title="" :visible.sync="dialogVisible" width="690px" :close-on-click-modal="false"
                :modal-append-to-body="false" :before-close="handClose">
                <div ref="preview">

                </div>
            </el-dialog>
        </div>
    </div>

</template>

<script>
import uploadVue from '../center/upload.vue'
import axios from "axios";
let docx = require("docx-preview");
import baseUrl from '../../api/baseUrl.js'

export default {
    data() {
        return {
            dialogVisible: false,
            payDialogVisible: false,
            radio: '1',
            input: '',
            personList: [
                {
                    name: '被授权主体',
                    msg: '',
                    placeholder: '例: 公司名称/个人姓名',
                    tips: '注：必须与付款方保持一致，否则无法开具',
                    purposeFlag: true
                },
                // {
                //     name: '歌曲用途',
                //     msg: '',
                //     placeholder: '请输入歌曲用途',
                //     purposeFlag: false
                // },
            ],
            purposeFlag: false,
            purpose: '',
            qualificat: '',//一半纳税人资质
            deposit_info: '',//存款
        }
    },
    components: {
        uploadVue
    },
    methods: {

        taxpayer(val) {
            this.qualificat = val
        },
        deposit(val) {
            this.deposit_info = val
        },
       async handClick() {
            this.dialogVisible = true
            // let data = await this.$home.previewCert({id:this.orderId})
            // console.log(data);
            // return
            // 请求的 URL 地址
            var url = baseUrl + '/index/previewCert'
            // 请求的参数对象
            let that = this
            // 调用 axios.get() 发起 GET 请求
            axios.get(url, {
                responseType: "blob",
                params:{
                    id:this.orderId
                }
            }).then(function (res) {
                // res.data 是服务器返回的数据
                console.log(res)
                const blob = new Blob([res.data])
                docx.renderAsync(blob, that.$refs.preview);
            })
            return
        },
        handClose() {
            this.dialogVisible = false
        },
        handlePayClose() {
            this.payDialogVisible = false
        },
        putIn() {
            let val = {
                order_id: this.orderId * 1,//订单id
                purpose: this.purpose,//歌曲用途
            }
            // return
            if (this.purpose == '') return this.$msg('error', '提示', '歌曲用途不能为空')
            if (this.applyInfo.type == 2 && !this.applyInfo.qualificat && !this.applyInfo.deposit_info) {
                val.qualificat = this.qualificat
                val.deposit_info = this.deposit_info
                if (this.qualificat == '') return this.$msg('error', '提示', '一般纳税人资质不能为空')
                if (this.deposit_info == '') return this.$msg('error', '提示', '开户许可证或基本存缴信息证明不能为空')
            }
            this.$home.applyEmpower(val).then(res => {
                if (res.code == 200) {
                    this.$emit('update', 'authorization')
                    this.$msg('success', '提示', res.msg)
                    this.payDialogVisible = false
                } else {
                    this.$msg('error', '提示', res.msg)
                }
            }).catch(err => {
                //console.log(err);
            })
        }
    },
    props: {
        applyInfo: {
            type: Object,
            default: () => { }
        },
        orderId: {
            type: [String, Number]
        },
        flag: {
            type: Number
        },
    },
    watch: {
        applyInfo(val) {
            if (val.id) {
                console.log(val);
                if (val.type == 1) {
                    this.personList[0].msg = this.applyInfo.real_name
                } else if (val.type == 2) {
                    this.personList[0].msg = this.applyInfo.company_name
                }
            }
        },
        orderId(val) {
            if (val && this.payDialogVisible) {
                let data = {
                    id: val
                }
                this.$home.orderInfo(data).then(res => {
                    if (res.code == 200) {
                        if (res.data.purpose) {
                            this.purpose = res.data.purpose
                            this.purposeFlag = true
                        } else {
                            this.purpose = ''
                            this.purposeFlag = false
                        }
                    }
                }).catch(err => {
                })
            }
        },
        flag(val) {
            let data = {
                id: this.orderId
            }
            this.$home.orderInfo(data).then(res => {
                if (res.code == 200) {
                    if (res.data.purpose != '') {
                        this.purposeFlag = true
                    }
                }
            }).catch(err => {
            })
        },
        payDialogVisible(val) {
            if (!val) {
                this.purposeFlag = false
                this.$parent.orderId = ''
            }
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep .docx-wrapper {
    background-color: transparent;
}

::v-deep .docx-wrapper>section.docx {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    box-shadow: none;
}

.wordPreview {
    ::v-deep .el-dialog {
        max-height: 700px;
        overflow: auto;
    }
}

.payFooter {
    text-align: right;
}

.top {
    position: relative;
}

.but {
    width: 180px;
    height: 180px;
    position: absolute;
    bottom: 90px;
    right: 150px;
}


::v-deep .el-dialog__header {
    padding: 20px 30px;
    padding-bottom: 10px;
}

::v-deep .el-dialog__footer {
    text-align: left;
    padding: 20px 30px;
}

::v-deep .el-dialog__body {
    margin: 0 30px;
    padding: 0;
    // padding-bottom: 10px;

    .el-divider--horizontal {
        margin: 14px 0 24px 0;
    }
}

::v-deep .el-dialog__title {
    font-weight: 600;
}


.payTitle {
    padding: 10px 0;
    border-bottom: 1px dashed #AAAAAA;
    padding-bottom: 24px;

    >div {
        display: flex;
        align-items: center;

        p {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
        }

        ::v-deep .el-radio__label {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
        }

        h2 {
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
        }
    }
}

.info {

    h3 {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
    }

    .payee {
        display: flex;
        // margin-top: 20px;
        align-items: center;

        p {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
        }
    }

    .info_box {
        display: grid;
        grid-gap: 24px 24px;
        margin-top: 20px;

        .info_item {

            .flex {
                display: flex;
                align-items: center;
                border-bottom: 1px solid #dcdfe6 !important;

                >div {
                    // flex-shrink: 0;
                    min-width: 100px;
                }
            }

            .tips {
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #AAAAAA;
                margin-top: 10px;
            }

            .info_item_name {
                // margin-bottom: 10px;

                display: flex;
                align-items: center;

                p {
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                }

                span {
                    font-size: 10px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #AAAAAA;
                    margin-left: 7px;
                }

            }
        }
    }
}

.tips {
    text-align: left;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-top: 24px;
}

::v-deep .el-input__inner {
    border: none;
    border-radius: 0;
    padding: 0;
}
</style>